"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableBody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const typings_1 = require("../../TableCore/typings");
const helpers_1 = require("../helpers");
const _1 = require("./");
const TableBodyEmpty_1 = require("./TableBodyEmpty");
class TableBody extends React.Component {
    constructor() {
        super(...arguments);
        this.activeTimeout = false;
        this.originalRowsLength = 0;
        this.transformedRows = [];
        this.state = {
            expandIndex: {},
        };
        this.transformRowsData = () => {
            const { rows, sortColumn, sortOrder } = this.props;
            const isDataFiltered = rows.length !== this.originalRowsLength;
            if (isDataFiltered) {
                this.transformedRows = this.specifyGroupsInRows(rows);
                this.originalRowsLength = rows.length;
            }
            return (0, helpers_1.sortTableRows)(this.transformedRows, sortOrder, sortColumn);
        };
        this.addGroupRowsMainRowData = (rows, tableType) => {
            return rows.map(row => {
                if (row.group) {
                    const mainRow = (0, helpers_1.getGroupMainRowData)(row.group, tableType);
                    return Object.assign(Object.assign({}, row), { mainRowData: mainRow });
                }
                return row;
            });
        };
        this.groupToggle = (event, groupIndex) => {
            if (this.activeTimeout) {
                return null;
            }
            const { tableWrapperRef, expandableWrapper } = this.props;
            // find, if current row is in range [0, maxVisibleRowCount-1]
            const clickedRow = event.currentTarget.parentElement.parentElement;
            const inTable = $(tableWrapperRef.current)
                .find('tbody:not(.table-row-group) tr')
                .toArray()
                .indexOf(clickedRow);
            if (inTable < this.props.maxVisibleRowCount) {
                this.activeTimeout = true;
                const el = $(clickedRow).parent().next();
                const height = el.height();
                if (this.state.expandIndex[groupIndex]) {
                    expandableWrapper.decreaseHeight(height);
                    setTimeout(() => {
                        this.activeTimeout = false;
                    }, 100);
                }
                else {
                    expandableWrapper.increaseHeight(height);
                    setTimeout(() => {
                        expandableWrapper.increaseHeight(el.height() - height);
                        this.activeTimeout = false;
                    }, 100);
                }
            }
            else {
                this.activeTimeout = false;
            }
            this.setState(prevState => ({
                expandIndex: Object.assign(Object.assign({}, prevState.expandIndex), { [groupIndex]: !prevState.expandIndex[groupIndex] }),
            }));
        };
    }
    render() {
        const { rows, columns, dictionary, isDesktop, maxVisibleRowCount, isTableExpanded, sortOrder, sortColumn, } = this.props;
        if (!rows || !rows.length) {
            return (0, jsx_runtime_1.jsx)(TableBodyEmpty_1.default, { columns: columns, dictionary: dictionary, isDesktop: isDesktop });
        }
        const updatedRows = this.transformRowsData();
        return updatedRows.map((rowInfo, rowIndex) => {
            const isInvisible = rowIndex > maxVisibleRowCount - 1 && !isTableExpanded;
            const groupIndex = rowInfo.id;
            const isExpanded = Boolean(this.state.expandIndex[groupIndex]);
            const isEven = (rowIndex + 1) % 2 === 0;
            if (rowInfo.group) {
                return ((0, jsx_runtime_1.jsx)(_1.TableBodyGroup, { groupInfo: rowInfo, columns: columns, dictionary: dictionary, isDesktop: isDesktop, groupToggle: this.groupToggle, isExpanded: isExpanded, isInvisible: isInvisible, isEven: isEven, sortOrder: sortOrder, sortColumn: sortColumn }, rowIndex));
            }
            return ((0, jsx_runtime_1.jsx)("tbody", { tabIndex: -1, "aria-hidden": isInvisible, className: `table-basic-row ${isEven ? 'even' : ''}`, children: (0, jsx_runtime_1.jsx)(_1.TableBodyRow, { rowInfo: rowInfo, columns: columns, dictionary: dictionary, isDesktop: isDesktop, clickableElementsTabIndex: isInvisible ? -1 : 0 }) }, rowIndex + 'tbody'));
        });
    }
    specifyGroupsInRows(rows) {
        const { tableType } = this.props;
        if (rows && rows.length) {
            let filteredRows;
            if (!tableType || tableType !== typings_1.TableTypeEnum.Software) {
                filteredRows = this.filterTableRows(rows, []);
            }
            else {
                filteredRows = this.sortSoftwareGroup(this.filterTableRows(rows, []));
            }
            return this.addGroupRowsMainRowData(filteredRows, tableType);
        }
        return [];
    }
    filterTableRows(arr, newArr) {
        if (!arr.length) {
            return newArr;
        }
        const group = [];
        let filteredArr = [];
        let docSetId = arr[0].docsetId;
        docSetId = docSetId ? docSetId.trim().toLowerCase() : docSetId;
        if (!docSetId) {
            group.push(arr[0]);
            filteredArr = arr.slice(1);
        }
        else {
            for (const row of arr) {
                row.docsetId && row.docsetId.trim().toLowerCase() === docSetId
                    ? group.push(row)
                    : filteredArr.push(row);
            }
        }
        // pre-sort group by useUserLanguage
        group.sort(this.sortByUserLanguage); // mutates array.
        group.length > 1
            ? newArr.push({
                group,
                id: docSetId,
            })
            : newArr.push(...group);
        // without current docsetId
        return this.filterTableRows(filteredArr, newArr);
    }
    // https://stackoverflow.com/questions/17387435/javascript-sort-array-of-objects-by-a-boolean-property/17387493
    sortByUserLanguage(x, y) {
        const setSortValue = (item) => {
            return item.isOnUserLanguage ? 2 : isItemOnGlobalLanguage(item);
        };
        return setSortValue(y) - setSortValue(x);
    }
    sortSoftwareGroup(data) {
        return data.map(rowGroup => {
            if (rowGroup.group) {
                rowGroup.group = rowGroup.group.sort((a, b) => {
                    return a.status.type - b.status.type !== 0
                        ? a.status.type - b.status.type
                        : b.updatedTimestamp - a.updatedTimestamp;
                });
            }
            return rowGroup;
        });
    }
}
exports.TableBody = TableBody;
function isItemOnGlobalLanguage(item) {
    return item.isOnGlobalLanguage ? 1 : 0;
}
